




































import { computed, defineComponent } from '@vue/composition-api';
import { getAngieUIComponent } from '~/selectors/selectorsMap';
import FCImage from '~/components/FCImage.vue';
import { useModal } from '~/composables/useModal';
import { ITrainingThumbnailExpectedAttrs } from './types';
import { trainingThumbnailComponentsWhitelist } from './helpers';

export default defineComponent({
  name: 'StoryblokTrainingThumbnail',
  components: {
    FCImage,
  },
  inheritAttrs: false,
  setup(_, context) {
    const {
      category,
      workoutName,
      trainer,
      workoutLength,
      videoPreview,
      video,
    } = context.attrs as ITrainingThumbnailExpectedAttrs;

    const textComponents = computed((): {
      category?:any,
      workoutName?:any,
      trainer?:any,
      workoutLength?:any,
    } => [
      {
        name: 'category',
        data: {
          component: 'ShortText',
          text: category,
          textColor: 'black',
          textTheme: 'heading-2',
          textAlignment: 'fc-text-left',
        },
      },
      {
        name: 'workoutName',
        data: {
          component: 'ShortText',
          text: workoutName,
          textColor: 'black',
          textTheme: 'text',
          textAlignment: 'fc-text-left',
        },
      },
      {
        name: 'trainer',
        data: {
          component: 'ShortText',
          text: trainer,
          textColor: 'black',
          textTheme: 'text',
          textAlignment: 'fc-text-left',
        },
      },
      {
        name: 'workoutLength',
        data: {
          component: 'ShortText',
          text: workoutLength,
          textColor: 'black',
          textTheme: 'text',
          textAlignment: 'fc-text-left',
        },
      },
    ]
      .filter(({ data }) => (data.text ?? '').length && trainingThumbnailComponentsWhitelist.has(data?.component))
      .reduce((acc, { data, name }) => ({ ...acc, [name]: data }), {}));

    return {
      validThumbnail: computed(() => Object.values(textComponents.value).length > 0),
      videoPreview,
      categoryProps: computed(() => getAngieUIComponent('ShortText', textComponents.value?.category)),
      trainerProps: computed(() => getAngieUIComponent('ShortText', textComponents.value?.trainer)),
      workoutLengthProps: computed(() => getAngieUIComponent('ShortText', textComponents.value?.workoutLength)),
      workoutNameProps: computed(() => getAngieUIComponent('ShortText', textComponents.value?.workoutName)),
      openModal() {
        const width = Math.min(680, Math.floor(window.innerWidth * 0.85));

        const { modalShow } = useModal({
          component: () => import('~/components/storyblok/VideoModal/VideoModal.vue'),
          componentProps: video,
          modalProps: {
            componentName: 'VideoModal',
            width,
            height: Math.floor(width / (16 / 9)),
            reset: true,
            classes: 'modal-border-radius',
          },
          options: {
            emit: context.emit,
            openEvent: {
              name: 'onPause',
              payload: true,
            },
            closeEvent: {
              name: 'onPause',
              payload: false,
            },
          },
        });

        modalShow();
      },
    };
  },
});
